import React, { useState } from 'react';
import { TextField } from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue';
import PropTypes from 'prop-types';
import { Autocomplete } from "@material-ui/lab";
import Tr from "translations/Translations";

function ContractorSelect({
                              formikProps,
                              id,
                              label,
                              items,
                              onChange = () => {},
                              className,
                              selected
                          }) {

    const formikValue = getObjectValue(id, formikProps.values, []);

    const [selectedOptions, setSelectedOptions] = useState(
        items.filter(item => formikValue.includes(item.value) || selected.includes(item.value))
    );

    const error = getObjectValue(id, formikProps.errors, false);
    const touched = getObjectValue(id, formikProps.touched, false);
    const submitCount = formikProps.submitCount;

    const handleChange = (event, newOptions) => {

        setSelectedOptions(newOptions);

        const newValues = newOptions.map(option => option.value);
        formikProps.setFieldValue(id, newValues);

        onChange(newOptions);
    };

    const handleBlur = () => {
        formikProps.setFieldTouched(id, true, true);
    };

    const showError = (submitCount > 0 || touched) && Boolean(error);

    return (
        <Autocomplete
            className={className}
            noOptionsText={Tr('no_options')}
            onChange={handleChange}
            onBlur={handleBlur}
            multiple
            options={items}
            getOptionLabel={option => option.label}
            value={selectedOptions}
            filterSelectedOptions
            disableCloseOnSelect
            renderInput={params => (
                <TextField
                    {...params}
                    variant="standard"
                    label={label}
                    placeholder={Tr('contractors')}
                    fullWidth
                    error={showError}
                    helperText={showError ? error : ''}
                />
            )}
        />
    );
}

ContractorSelect.propTypes = {
    formikProps: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })
    ),
    className: PropTypes.string,
    onChange: PropTypes.func,
};

ContractorSelect.defaultProps = {
    items: [],
    onChange: () => {},
};

export default ContractorSelect;